// [init]
import authState from '../../restricted/Auth'
export default {


	namespaced: true,

	state: {
		// Listing of all customers ( Array )
		customersAddressList: [],

		// Current CustomerAddress being manipulated ( viewed or edited ) ( Object )
		status: '',
		activeCustomerAddress: {}
	},

	mutations: {

		// Update customerList with new list
		// @params: Array
		updateCustomerAddressList( state, newList ) {
			state.customersAddressList = newList;
		},

		// Add a customer into customerList
		addCustomerAddress( state, newCustomerAddress ) {
			state.customersAddressList.push( newCustomerAddress );
		},

		// Delete a customer from customerList
		// @params: identifier (String)
		deleteCustomerAddress( state, identifier ) {
			state.customersAddressList = state.customersAddressList.filter( address => {
				return address.id != identifier;
			} );
		},

		// Update the current active CustomerAddress object
		// @params: newActiveCustomerAddress (Object)
		updateActiveCustomerAddress( state, newActiveCustomerAddress ) {
			state.activeCustomerAddress = newActiveCustomerAddress;
		},

		// Change status of customerForm
		// @params: newStatus (String)
		updateStatus( state, newStatus ) {
			state.status = newStatus;
		},

		resetState( state ) {
			state.status = '';
			state.activeCustomerAddress = {};
		}

	},

	actions: {

		/* 
		*  /GET customers-addresses API
		*  Get all customers from the server
		*  @return: Array
		*/
		getArea( { commit, state }, params ) {

			commit( 'resetState' );

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/areas-postal',
					params: params,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					resolve( response.data );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET customers-addresses API
		*  Get all customers from the server
		*  @return: Array
		*/
		getCustomerAddresses( { commit, state } ) {

			commit( 'resetState' );

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/customers-addresses',
					params: {
						trash: '*',
						from: 0,
						size: 9999999
					},
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateCustomerAddressList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET/:id customers-addresses API
		*  Get a single customer's address from the server
		*  @params: identifier
		*  @return: Object
		*/
		getSingleCustomersAddresses( { commit, state }, identifier ) {

			commit( 'resetState' );

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/customers-addresses',
					params: {
						customerID: identifier
					},
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateCustomerAddressList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET/:id customers-addresses API
		*  Get a single customer from the server
		*  @params: Array (due to vuex limitations)
		*  [0]: identifier (String)
		*  [1]: action (String: view/edit)
		*  @return: Object
		*/
		getSingleAddress( { commit, state }, params ) {

			const identifier = params[0];
			const action = params[1];

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/customers-addresses/' + identifier,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateActiveCustomerAddress', response.data );
					commit( 'updateStatus', action );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST customers-addresses API
		*  Add a new customer to the server
		*  @params: Object (customers data)
		*  @return: Object
		*/
		addCustomerAddress( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {
                if(data.customerID == null || data.customerID == undefined){
					data.customerID = authState.state.id
                }
				const postData = {
					customerID: data.customerID,
					label: data.label,
					type: data.type,
					isPrimary: data.isPrimary,
					addressLine1: data.addressLine1,
					addressLine2: data.addressLine2,
					addressLine3: data.addressLine3,
					country: data.country,
					postal: data.postal,
					latitude: data.latitude,
					longitude: data.longitude,
					hasPets: data.hasPets,
					languagePreference: data.languagePreference,
					genderPreference: data.genderPreference,
					areaID: data.areaID
				};

				global.axios.request({
					method: 'post',
					url: '/customers-addresses',
					validateStatus: ( status ) => { return status == 201; },
					data: postData
				})
				.then(response => {
					commit( 'addCustomerAddress', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});


		},

		/* 
		*  /POST/:id customers-addresses API
		*  Edits an existing customer into the server
		*  @params: Object (customers data)
		*  @return: Object
		*/
		editCustomerAddress( { commit, state }, data ) {

			return new Promise ((resolve, reject ) => {

				const postData = {
					customerID: data.customerID,
					label: data.label,
					type: data.type,
					isPrimary: data.isPrimary,
					addressLine1: data.addressLine1,
					addressLine2: data.addressLine2,
					addressLine3: data.addressLine3,
					country: data.country,
					postal: data.postal,
					latitude: data.latitude,
					longitude: data.longitude,
					hasPets: data.hasPets,
					languagePreference: data.languagePreference,
					genderPreference: data.genderPreference,
					areaID: data.areaID
				};

				global.axios.request({
					method: 'post',
					url: '/customers-addresses/' + data.id + '/update',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					commit( 'addCustomerAddress', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /DELETE/:id customers-addresses API
		*  Removes an existing customer into the server
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		deleteCustomerAddress( { commit, state }, identifier ) {

			return new Promise ((resolve, reject ) => {

				global.axios.request({
					method: 'post',
					url: '/customers-addresses/' + identifier + '/trash',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'deleteCustomerAddress', identifier );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST/:id/untrash customers API
		*  Restores a customer into the server from the trash
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		untrashCustomerAddress( { commit, state }, identifier ) {

			return new Promise ( (resolve, reject) => {

				global.axios.request({
					method: 'post',
					url: '/customers-addresses/' + identifier + '/untrash',
					validateStatus: ( status ) => { return status == 200; },
				})
				.then(response => {
					const updatedList = state.customersAddressList.map(item => {
						if (item.id === identifier ) {
							let holder = item;
							holder.trash = 0;
							return holder;
						} else {
							return item;
						};
					});
					commit( 'updateCustomerAddressList', updatedList );
				})
				.catch(error => reject( error ));

			});

		},

		reset( { commit, state } ) {
			commit( 'resetState' );
		}

	}
}


// WEBPACK FOOTER //
// ./src/custom/controllers/Customers-addresses.js